import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import configureStore, { history } from "./redux/configureStore";
import { ConnectedRouter } from "connected-react-router";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import theme from "./theme";
import { ThemeProvider } from "@material-ui/styles";

import { configure } from "mobx";

import "normalize.css";
import "react-phone-number-input/style.css";
import "./assets/css/style.scss";
import "./assets/css/style.css";
import "./assets/css/style-for-all.scss";
import reg from "./serviceWorker";
import Pusher from "pusher-js";

window.Pusher = Pusher;
Pusher.logToConsole = false;

if (process.env.NODE_ENV === "development") require("./errors.js");

configure({
	enforceActions: "never",
});

configureStore().then(({ store, persistor }) => {
	ReactDOM.render(
		<Provider store={store}>
			<PersistGate persistor={persistor} loading={null}>
				<ThemeProvider theme={theme}>
					<ConnectedRouter basename="/" history={history}>
						<App />
					</ConnectedRouter>
				</ThemeProvider>
			</PersistGate>
		</Provider>,
		document.getElementById("root")
	);
});

if (process.env.REACT_APP_YES_APP === undefined) reg();
